/* global $ */

angular.module('cian.serp')
	.directive('serpItemJquery', ['$log', function($log) {
    var fotoramaReadyCounter = 0;

		var SerpItem = function (elNode) {
			var self = this,
					fotoramaActiveIndex = 0,
					fotoramaClicked = false,
					$This = $(elNode);

			self._id = parseInt($This.attr('oid'));
			self._position = parseInt($This.attr('position'));
			self._isSimilar = false;
			self._offer = window._offers[self._id];
			if (!self._offer) {
				self._isSimilar = true;
				self._offer = window._similarOffers[self._id];
			}
			self.state = {
				isMapOpened: false,
				isMapInited: false,
				isGalleryOpened: false,
				isGalleryInited: false,
				isFotoramaFirstItemLoaded: false
			};

			self.$This = $This;
			self.$MapTrigger = $This.find('.js-serp-item-map-trigger');
			self.$MapContainer = $This.find('.js-serp-item-map-col');
			self.$Map = $This.find('.js-serp-item-map');
			self.$Phone = $This.find('.js-serp-item-phone');
			self.$PhoneTrigger = $This.find('.js-phone-show');
			self.$ContextTrigger = $This.find('.js-serp-item-context-trigger');
			self.$ContextPopup = $('.js-serp-item-context-popup');
			self.$PremiumTrigger = $This.find('.js-serp-item-premium-trigger');
			self.$CommentPopup = $('.js-serp-item-comment-popup');
			self.$AddedTrigger = $This.find('.js-serp-item-added-trigger');
			self.$PhotoTrigger = $This.find('.js-serp-item-photo-trigger');
			self.$Photos = $This.find('.js-serp-item-photo');
			self.$AddressStr = $This.find('.serp-item__address-precise a');
			self.$Fotorama = $This.find('.serp-item__fotorama');
			self.$FotoramaCount = $This.find('.js-current-fotorama');
			self.$CardLink = $This.find('.serp-item__card-link');
			self.map = null;

			function initFotorama() {
        if (self._offer.photos.length > 0 && window.performance && window.performance.mark) {
          if (fotoramaReadyCounter === 0) {
            window.performance.mark('cserp.fotorama-start');
          }
          fotoramaReadyCounter++;
        }
				self.$Fotorama
						.on('fotorama:ready', function () {
              if (self._offer.photos.length > 0 && window.performance && window.performance.mark) {
                setTimeout(function(){
                  fotoramaReadyCounter--;
                  if (fotoramaReadyCounter === 0) {
                    window.performance.mark('cserp.fotorama-end');
                  }
                }, 0);
              }
            })
						.fotorama({
							data: self._offer.photos,
							nav: false,
							loop: true,
							fit: 'cover',
							height: '246px',
							width: '100%'
						})
						.on('fotorama:load', function (e, fotorama, extra) {
							fotoramaActiveIndex = fotorama.activeFrame.i;
							if (!self.state.isFotoramaFirstItemLoaded) {
								setTimeout(function() {
									self.$Fotorama.css('background-image', 'none');
									self.$Fotorama.removeClass('serp-item__fotorama_nospinner');
								}, 1000);
							}
							self.state.isFotoramaFirstItemLoaded = true;
						})
						.on('fotorama:showend', function (e, fotorama, extra) {
							if (fotoramaActiveIndex !== 0 && fotoramaActiveIndex !== fotorama.activeFrame.i && !fotoramaClicked) {
								window.ca && ca('event', {
									name: 'oldevent',
									category: 'Listing',
									action: 'slide_photo',
									label: 'from_newlist'
								});
							fotoramaClicked = true;
							}
							self.$FotoramaCount.text(fotorama.activeFrame.i);
						});
			}

			if (window.WURFL && !window.WURFL.is_mobile) {
				self.$This.addClass('serp-item_not-mobile');
				if (self.$Fotorama.fotorama) {
					// если плагин загружен
					initFotorama();
				} else {
					// если fotorama подгружается асинхронно в файле serp-scripts-async.js
					document.addEventListener('SerpScriptsAsyncLoaded', initFotorama);
				}
			} else {
				self.$This.addClass('serp-item_mobile');
				self.$Fotorama.on('click', function() {
					self.$PhotoTrigger.click();
				});
			}

			self.$PhotoTrigger.on('click', function(){
				if (self.state.isMapOpened) {
					self.$MapTrigger.click();
				}
				self.state.isGalleryOpened = !self.state.isGalleryOpened;
				self.$Photos.toggle(self.state.isGalleryOpened);
				self.$PhotoTrigger.find('.s-button__text').text(self.state.isGalleryOpened ? 'Скрыть фото' : 'Показать фото');

				if (!self.state.isGalleryInited) {
					self.state.isGalleryInited = true;

					var photosToAppend = [],
							photosObj = window.cianConfig['photos_' + self._id];

					for (var i = 0; self._offer.photos.length > i; i++){
						photosToAppend.push('<div class="serp-item__photos__item"><img src="'+ self._offer.photos[i].thumb +'" height="246"/></div>');
					}

					self.$Photos.html(photosToAppend.join(''));
					self.$Photos
							.flickity({
								"imagesLoaded": true,
								"percentPosition": false,
								"freeScroll": true,
								"cellAlign": "left",
								"contain": true,
								"initialIndex": 0
							});
					setTimeout(function(){
						self.$Photos.flickity('select', 0);
					}, 100);
				}

			});


			// Боремся с переносом 4-ый и т.п.
			self.$AddressStr.each(function () {
				var str = $(this).text().replace(/(^|[^a-zA-Zа-яА-Я])(\d+)-([a-zA-Zа-яА-Я]+)/g, "$1$2&#8209;$3");
				$(this).html(str);
			});


			/* Карта */
			self.$This.on('click', '.js-serp-item-map-trigger', function() {
				if (self.state.isGalleryOpened) {
					self.$PhotoTrigger.click();
				}
				self.$MapContainer.toggle();
				_toggleMap();
			});

			function _toggleMap() {
				if (!self.state.isMapInited) {
					_initMap();
				}

				self.state.isMapOpened = !self.state.isMapOpened;

				window.ca && ca('event', {
					name: 'oldevent',
					category: 'Listing',
					action: self.state.isMapOpened ? 'open_map' : 'hide_map',
					label: 'from_newlist',
				});

				self.$MapContainer.toggle(self.state.isMapOpened);
				self.$MapTrigger.find('.s-button__text').html(self.state.isMapOpened?'Скрыть карту':'Показать на карте');
				self.$MapTrigger.find('.s-popup__menu__item__text').text(self.state.isMapOpened?'Скрыть карту':'Показать на карте');
				// self.$MapTrigger.toggleClass('s-button_active', self.state.isMapOpened);
				// $This.toggleClass('serp-item_expanded', self.state.isMapOpened);
			}



			function _initMap() {
				if (self.state.isMapInited) return;

				// не на вершине файла, потому что там недоступен ymaps
				// когда нет модульности и ymaps грузятся с defer
				var ymapsRequire = (function () {
					try {
						return require('../../../../newbuild/src/serp/helpers/ymaps-reqiure.js');
					} catch (err) {
						return ymaps.modules.require.bind(ymaps.modules);
					}
				}());

				ymapsRequire(['Map', 'control.ZoomControl'], function (Map) {
					self.map = new Map(self.$Map[0], {
						// В window._offers координаты в формате latlng
						// На новых фильтрах везде работаем в формате lngLat
						center: [self._offer.center[0], self._offer.center[1]],
						zoom: 14,
						behaviors: ['drag', 'dblClickZoom', 'multiTouch'],
						controls: []
					}, {
						suppressMapOpenBlock: true
					});
					self.map.controls.add('zoomControl', {
						position: {
							top: 70,
							left: 10
						}
					});
					_putMarker();
					self.state.isMapInited = true;
				});
			}

			// выполняется только после _initMap,
			// потому можно использовать ymaps.modules.require
			function _putMarker() {
				ymaps.modules.require(['Placemark'], function (Placemark) {
					self.map.geoObjects.add(
							new Placemark([self._offer.center[0], self._offer.center[1]], {
							}, {
								iconLayout: 'default#image',
								iconImageHref: '/static/images/markers/map_home_spot@2x.png',
								iconImageSize: [52, 48],
								iconImageOffset: [-20, -54]
							})
					);
				});
			}

			self.$CardLink.on('click', function() {
				var trackingAction = 'to_card' + (self._isSimilar ? '_similar' : '');
				window.ca && ca('event', {
					name: 'oldevent',
					category: 'Listing',
					action: trackingAction,
					label: 'card_detail_in_newlist',
					ecommerce: {
						click: {
							actionField: {
								list: 'listing'
							},
							products: [ self._offer.phone_data_layer ],
						}
					}
				});
			});

			/* Телефон */
			self.$PhoneTrigger.on('click', function() {
				var trackingAction = 'Open_listing_agent_block' + (self._isSimilar ? '_similar' : '');
				window.ca && ca('eventSite', {
					name: 'oldevent',
					category: 'Phones',
					action: trackingAction,
					label: self._offer.ga_event_action,
					page: {
					  pageType: 'CardAgent',
					  siteType: 'desktop',
					},
					products: [{
					  id: self._offer.phone_data_layer.id,
					  offerType: 'offer',
					  position: self._position,
					}],
				});

				_sendCriteoEvent();
				window.yaCounter34229100 && yaCounter34229100.reachGoal('open_phone_listing', {phones_url: self._offer.ga_event_action });
				_sendAdmitadEvent();
				monitor.track('phoneopen', {'source': 'site', 'oid': self._offer.id, 'deal_type': self._offer.deal_type, 'offer_type': self._offer.offer_type});
				self.$Phone.html(self._offer.phone);
				self.$Phone.addClass('serp-item__phone_opened');
			});

			self.$PhoneTrigger.on({
				mouseenter: function() {
					self.$PhoneTrigger.addClass('s-button_action serp-item__phone_highlight');
				},
				mouseleave: function() {
					self.$PhoneTrigger.removeClass('s-button_action serp-item__phone_highlight');
				}
			});

			/* Дата */
			self.$AddedTrigger.on({
				'mouseenter': function() {
					self.$AddedTrigger.html(self._offer.added.strict);
				},
				'mouseleave': function() {
					self.$AddedTrigger.html(self._offer.added.humanized);
				}
			});

			self.$This.removeClass('serp-item_not-inited');

			function _sendAdmitadEvent() {
				var oid = self._offer.offer_type + self._offer.deal_type + '_' + self._offer.realty_id;

				if (window.cianConfig && window.cianConfig.admitad && window.cianConfig.admitad.send) {
					window.cianConfig.admitad.send('lead', oid);
				}
			}

			function _sendCriteoEvent() {
				if (!window.criteo_q) return;

				try {
					var parts = [
						{ event: "setAccount", account: 24860 },
						{ event: "setSiteType", type: window.cianConfig.criteo.site_type },
						{ event: "trackTransaction",
							id: self._offer.realty_id,
							new_customer: window.cianConfig.criteo.new_customer,
							deduplication: window.location.search.toLowerCase().indexOf('utm_source=criteo') > -1?1:0,
							item: [{ id: self._offer.realty_id, price: self._offer.price.rur, quantity: '1'}]
						}
					];
					if (window.cianConfig.criteo.email) {
						parts.push({ event: "setHashedEmail", email: window.cianConfig.criteo.email });
					}
					window.criteo_q['push'].apply(this, parts);
				} catch (err) {
					$log.debug('Ошибка Criteo:', err);
				}
			}
		};

		return {
			link: function(scope, element, attrs) {
				new SerpItem(element[0]);
			}
		};
	}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.serpItemJquery.js
// module id = 500
// module chunks = 0